import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const GlobalFunnelReports = lazy(() =>
  import("@scenes/GlobalFunnelReports/GlobalFunnelReports").then((module) => ({
    default: module.GlobalFunnelReports,
  }))
);

export const globalFunnelReportsNRO: NavigationRoutingObject = {
  Component: GlobalFunnelReports,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "analytics",
  tag: "new",
  heading: (t: I18nT<"dashboard-navigation">) => t("funnel-reports-sidebar-menu-option", "Funnel Reports"),
  pageNameForTracking: () => "Funnel Reports",
  getDeveloperNavigationAllowed: ({ featureOn, isImpersonating, hasPermission }) => {
    const userHasViewReportingPermission = hasPermission("appGroup", {
      permission: "viewReporting",
    });
    return featureOn("global_funnel_reports") && (isImpersonating || userHasViewReportingPermission);
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/funnel_reports/:appGroupId",
};
